import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useEmitPushHistory } from '../../../hooks/App/useEmitPushHistory';

export const History: FC<{ children: any }> = ({ children }) => {
  const pathname = useLocation().pathname;
  useEmitPushHistory(pathname);

  return children;
};
